import React from 'react'

function TextArea({ ...rest }) {
    return (
        <textarea
            {...rest}
            rows={6}
            className='w-full border border-gray-300 px-4 py-3 text-xs rounded-lg outline-none'
        />
    )
}

export default TextArea